// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "30206ef9340fc538beba1e33a4acc47238f5c194/static/css/" + chunkId + "." + "f83a2947" + ".chunk.css";
};